import i18n from 'constants/translation/i18n';

const translate = (t: any, key: string) => (t ? t(key) : i18n.t(key));

const riskAndControlAreas = (t?: any) => {
  return [
    {
      area: 'structureAndMaintain',
      title: translate(t, 'STRUCTURE_AND_MAINTAIN'),
      href: '/risk-controls/structure_maintain'
    },
    {
      area: 'connectAndGovern',
      title: translate(t, 'CONNECT_AND_GOVERN'),
      href: '/risk-controls/connect_and_govern'
    },
    {
      area: 'assessAndTest',
      title: translate(t, 'ASSESS_AND_TEST'),
      href: '/risk-controls/assess_and_test'
    }
  ];
};

export const structureAndMaintainAreas = (t?: any) => {
  return [
    {
      area: 'allocation',
      title: translate(t, 'ALLOCATION_MAIN'),
      href: '/risk-controls/allocation'
    },
    {
      area: 'inventories',
      title: translate(t, 'INVENTORIES'),
      href: '/risk-controls/inventories'
    }
  ];
};

export const connectAndGovernAreas = (t?: any) => {
  return [
    {
      area: 'dnd',
      title: translate(t, 'BUSINESS_PROCESS_MAPPING'),
      href: '/risk-controls/dnd'
    },
    {
      area: 'reportings',
      title: translate(t, 'REPORTS'),
      href: '/risk-controls/reportings'
    },
    {
      area: 'dependencies',
      title: translate(t, 'DEPENDENCY_TREE'),
      href: '/dependency_bpr'
    },
    {
      area: 'dashoard',
      title: translate(t, 'DASHBOARD'),
      href: '/internal_controls/dashboard'
    }
  ];
};

export const assessAndTestAreas = (t?: any) => {
  return [
    {
      area: 'controlsAttestation',
      title: t ? t('CONTROL_ATTESTATION') : i18n.t('CONTROL_ATTESTATION'),
      href: '/controlsAndRiskAllocation/controlAttestation'
    },
    {
      area: 'controlsTestingDesign',
      title: t ? t('CONTROLS_TEST_DESIGN') : i18n.t('CONTROLS_TEST_DESIGN'),
      href: '/controlsAndRiskAllocation/controlsTestingDesignEffectiveness'
    },
    {
      area: 'controlsTesting',
      title: t ? t('CONTROLS_TEST') : i18n.t('CONTROLS_TEST'),
      href: '/controlsAndRiskAllocation/controlsTesting'
    }
  ];
};

export default riskAndControlAreas;
